import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "../auth/auth.service";
import { StorageService } from "./storage-Service";
import { Router } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class ErrorHandlingInterceptorService implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err) => {
        let errorMessage = "Error Occured";

        if (typeof err === "string") {
          errorMessage = err;
        } else {
          if (err.status === 401) {
            this.storageService.removeAccessToken();

            // this.authService.getAccessControl().subscribe((res) => {
            //   this.storageService.saveAccessToken(res);
            // });
          }
          if (err.status === 500) {
            errorMessage = "An error occurred, pls try again";
          }
          if (err.message !== null || err.message !== undefined) {
            errorMessage = err.message;
          }

          if (err.error instanceof ErrorEvent) {
            errorMessage = "An error occurred, pls try again";
          } else if (err.error instanceof ProgressEvent) {
            errorMessage = "Unable to connect to the service";
          } else if (err.error instanceof ArrayBuffer) {
            errorMessage = "An error occurred, Unable to generate receipt";
          } else if (
            err.error.responseMessage === "Payment already completed "
          ) {
            errorMessage = err.error.responseMessage;
          } else {
            errorMessage = err?.error?.responseMessage?.replace(/_/g, "");
          }
        }

        // return new Error(errorMessage);

        return throwError(err);
      }),
    );
  }
}
